module.exports = __webpack_public_path__ + "img/shopping-cart-2-fill.4f0a04d0.svg";